var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.583 5h3.25a.208.208 0 00.148-.356L12.689.354a.208.208 0 00-.356.146v3.25c0 .69.56 1.25 1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.125 5.833h-3.542A2.083 2.083 0 0111.5 3.75V.207A.208.208 0 0011.292 0H2.333C1.413 0 .667.746.667 1.667v16.666c0 .92.746 1.667 1.666 1.667h13.334c.92 0 1.666-.746 1.666-1.667V6.04a.208.208 0 00-.208-.207z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.2b5f058c.svg";
export { ForwardRef as ReactComponent };